/**
 * Design tokens + layout constants for the redesigned homepage.
 * Spacing follows an 8-based scale (8/12/16/24/32/48/64/96); sections use
 * 80px (mobile) → 112px (desktop) vertical padding inside a 1280px container.
 */
export const H = {
  navy: "#071B3A",
  navy2: "#0B2348",
  blue: "#1769FF",
  blue2: "#2563EB",
  bg: "#F7F9FC",
  text: "#13233F",
  muted: "#667085",
  line: "#E4E9F2",
};

export const HOME_WRAP = "mx-auto w-full max-w-[1320px] px-5 sm:px-8 lg:px-10";
export const SECTION_Y = "py-20 lg:py-28";

/** Shared primary / secondary button styles (lift + blue glow, arrow nudge via `group`). */
export const BTN_PRIMARY =
  "group inline-flex h-[52px] items-center justify-center gap-3 rounded-[10px] bg-[#1769FF] px-7 text-[13px] font-semibold uppercase tracking-[0.12em] text-white shadow-[0_10px_30px_-12px_rgba(23,105,255,0.75)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#0F5CE6] hover:shadow-[0_18px_38px_-12px_rgba(23,105,255,0.9)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#071B3A]";
export const BTN_GHOST_DARK =
  "inline-flex h-[52px] items-center justify-center rounded-[10px] border border-white/30 bg-white/[0.04] px-7 text-[13px] font-semibold uppercase tracking-[0.12em] text-white backdrop-blur-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-white/70 hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-[#071B3A]";
